import React from 'react';
import { ProductCard } from './productCard';
import type { ProductItemProps } from './productItemTypes';

export const RecommendedItem = ({ hit, components }: ProductItemProps) => (
  <ProductCard hit={hit} components={components} isRecommended />
);
